//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EditOtherTenantsFeatureFlags: FeatureFlag = {"Id":"EditOtherTenantsFeatureFlags","Label":"Edit Other Tenants Feature Flags","Impact":"Can toggle feature flags for tenants other than the current one","Mode":2,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":5};
